<template>
    <div  v-if="estado" class="contenedor-cargando">
        <div class="cargando">
            <img :src="$cdn + '/Cajasan-loading.gif'" title="" alt="">
            <p>Cargando . . .</p>
        </div>
    </div>
</template>

<script>
import store from '../../store';

export default {
  name: 'Cargando',
  computed: {
    estado() {
      let data = store.getters.getCargando;
      return data.estado;
    },
  },
}
</script>
<style scoped lang="scss">
.contenedor-cargando {
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1200;

    .cargando {
        padding: 30px 50px;
        border-radius: 20px;
        background-color: #FFFFFF;
        text-align: center;

        p {
            margin-top: 20px;
            font-family: 'Source Sans Pro', sans-serif;
            font-size: 26px;
            font-weight: 500;
            color:#6F778E;
            text-align: left;
            animation: parpadear 3s infinite;
        }
    }
}

@keyframes parpadear {
    0% { opacity: 0 }
    50% { opacity: 1 }
    100% { opacity: 0 }
}
</style>
